<template>
  <div class="text w100 baff">
    <!-- <div class="addbutt center coff ba6e ru5 cursor mb20" @click="addtextstuts = true">新增</div> -->
    <div>
      <el-table :data="tableData"
        style="width: 100%;font-size: 12px;font-weight: 400; background: rgba(167, 169, 192, 0.25);"
        :header-cell-style="{ background: 'rgba(167, 169, 192, 0.25)', color: '#000' }">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column prop="title" label="素材标题"></el-table-column>
        <el-table-column prop="zekou" label="折扣码" width="100"></el-table-column>
        <el-table-column prop="zekoutext" label="折扣描述"></el-table-column>
        <el-table-column prop="url" label="推广链接"></el-table-column>
        <el-table-column prop="pt" label="上传平台"></el-table-column>
        <el-table-column prop="stuts" label="上线状态" width="120">
          <template slot-scope="scope">
            <div class="tabbutt center ru5 cursor but1" v-if="scope.row.stuts == 1" size="mini">正在使用</div>
            <div class="tabbutt center ru5 cursor but2" v-if="scope.row.stuts == 2" size="mini">已停用</div>
            <div class="tabbutt center ru5 cursor but3" v-if="scope.row.stuts == 3" size="mini">审核中</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div>
        <Pagination :pageNo="currentPage" :pageSize="size" :total="total" :continues="4" @getPageNo="currentChange" />
      </div> -->
      <div v-if="addtextstuts" class="addtext">
        <i class="el-icon-close cursor" @click="addtextstuts = false"></i>
        <div class="addtext_top">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="1px" class="demo-ruleForm">
            <div class="flex w100 inform">
              <div class="inpu1">
                <div class="mb10 sz16">*素材标题</div>
                <el-form-item label="" prop="name">
                  <el-input style="width:100%;" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </div>
              <div class="inpu2">
                <div class="mb10 sz16">*折扣码</div>
                <el-form-item label="" prop="name">
                  <el-input style="width:100%;" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="flex w100 inform">
              <div class="inpu1">
                <div class="mb10 sz16">*推广链接</div>
                <el-form-item label="" prop="name">
                  <el-input style="width:100%;" v-model="ruleForm.name"></el-input>
                </el-form-item>
              </div>
              <div class="inpu2">
                <div class="mb10 sz16">*选择平台</div>
                <div class="pt flex mb5">
                  <div class="pt1 ru5 cursor" @click="avticli(1)">
                    <div class="gg ru50">
                      <div v-if="avtiStuts == 1" class="correct ru50"></div>
                    </div>
                    <div class="w100 center">
                      <img
                        src="https://fosho-profilephoto.oss-cn-shenzhen.aliyuncs.com/affiliate_networks/avantlink%20o.png"
                        alt="">
                    </div>
                    <div class="w100 center co77 sz14 ptbutt">
                      AvantLink
                    </div>
                  </div>
                  <div class="pt1 ru5 cursor" @click="avticli(2)">
                    <div class="gg ru50">
                      <div v-if="avtiStuts == 2" class="correct ru50"></div>
                    </div>
                    <div class="w100 center">
                      <img
                        src="https://fosho-profilephoto.oss-cn-shenzhen.aliyuncs.com/affiliate_networks/shareasale%20o.png"
                        alt="">
                    </div>
                    <div class="w100 center co77 sz14 ptbutt">
                      ShareASale
                    </div>
                  </div>
                </div>
                <div style="font-size:12px;">如果没有您所选择的平台请至<span class="sqzx cursor" @click="goauth">授权中心</span>授权</div>
              </div>
            </div>
            <div class="flex w100 inform textarea_input">
              <div class="inpu1">
                <div class="mb10 sz16">*推广文案</div>
                <el-form-item label="" prop="name">
                  <el-input type="textarea" :rows="2" placeholder="" :autosize="{ minRows: 10, maxRows: 10 }"
                    v-model="ruleForm.textarea">
                  </el-input>
                </el-form-item>
              </div>
              
            </div>
            <!-- <div class="w100 submit_top flex"> -->
            
            <!-- </div> -->
          </el-form>
          <div class="submit ba6e coff ru5 center cursor sz16">添加</div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [ // 表格数据
        {
          id: '2759734',
          title: 'Best Camping Tent',
          zekou: '874830',
          zekoutext: 'Best Deal for Camping Tent',
          url: 'https://bestdealforcamping.com',
          pt: 'ShareASale',
          stuts: 1,
        },
        {
          id: '2759734',
          title: 'Camping Bottle',
          zekou: '874830',
          zekoutext: 'Best Bottle for Outdoor',
          url: 'https://bestbottle.com',
          pt: 'ShareASale',
          stuts: 2,
        },
        {
          id: '2759734',
          title: 'Drinkware for Outdoor',
          zekou: '874830',
          zekoutext: 'Best Deal for Drinkware',
          url: 'https://drinkwaredeal.com',
          pt: 'AvantLink',
          stuts: 3,
        }
      ],
      avtiStuts: 1,
      total: 0,
      size: 10,
      currentPage: 1,
      addtextstuts: false, // 新增弹窗
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        textarea: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        date1: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        date2: [
          { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        ],
        type: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' }
        ],
        desc: [
          { required: true, message: '请填写活动形式', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    currentChange(val) {

    },
    // 平台选择
    avticli(e) {
      this.avtiStuts = e
    },
    // 跳转授权中心
    goauth() {
      localStorage.setItem('isemitco', 0)
      let routeUrl = this.$router.resolve({ path: 'authorization', });
      window.open(routeUrl.href, '_blank');
    }
  }
}
</script>
<style lang="less" scoped>
.ru50 {
  border-radius: 50%;
}

.text {
  width: 100%;
  min-height: 100%;
  border: 1px solid rgba(166, 168, 191, 0.25);
  border-radius: 8px;
  background: #fff;
  padding: 15px;
  position: relative;

  .addbutt {
    height: 40px;
    width: 96px;
    line-height: 40px;
  }

  .tabbutt {
    width: 93px;
    height: 27px;
    line-height: 27px;
  }

  .but1 {
    background: rgba(0, 182, 155, 0.2);
    color: #00b69b;
  }

  .but2 {
    background: rgba(239, 56, 38, 0.2);
    color: #ef3826;
  }

  .but3 {
    background: rgba(98, 38, 239, 0.2);
    color: #6226ef;
  }

  .addtext {
    width: 1038px;
    // height: 534px;
    background: #fff;
    border: 1px solid #d8d8d8;
    border-radius: 9px 9px 9px 9px;
    position: absolute;
    top: 50px;
    left: 50%;
    margin-left: -519px;
    z-index: 1;
    padding: 25px 50px 40px 35px;
    .addtext_top{
      position: relative;
    }

    .inform {
      justify-content: space-between;
      /* 横向中间自动空间 */
      align-content: space-between;

      /* 竖向中间自动空间 */
      .inpu1 {
        width: 38%;
      }

      .inpu2 {
        width: 55%;

        .pt {
          width: 100%;
          justify-content: space-between;
          /* 横向中间自动空间 */
          align-content: space-between;

          /* 竖向中间自动空间 */
          .pt1 {
            width: 48%;
            height: 150px;
            border: 1px solid rgba(166, 168, 191, 0.25);
            padding-top: 40px;
            position: relative;

            img {
              max-width: 150px;
            }

            .gg {
              width: 18px;
              height: 18px;
              background: rgba(166, 168, 191, 0.25);
              position: absolute;
              right: 12px;
              top: 12px;
            }

            .ptbutt {
              position: absolute;
              bottom: 20px;
            }
          }
        }

        .sqzx {
          color: #5a8cff;
          text-decoration: underline #5a8cff;
          /*红色下划线*/
        }
      }
    }

    .textarea_input {
      margin-top: -120px;
      position: relative;
    }

    .submit_top {
      justify-content: flex-end;

    }

    .submit {
      width: 96px;
      height: 40px;
      line-height: 40px;
      position: absolute;
      bottom: 0;
      right: 0;
    }

    i {
      font-size: 20px;
      position: absolute;
      right: 5px;
      top: 5px;
    }
  }

  .correct {
    width: 18px;
    height: 18px;
    line-height: 20px;
    border: 1px solid #be3c6e;
    background-color: #be3c6e;
    position: relative;
    cursor: pointer;
  }

  .correct::before {
    position: absolute;
    content: " ";
    width: 7px;
    height: 13px;
    transform: rotate(45deg);
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    top: -2px;
    left: 4px;
  }
}
</style>
<style lang="less">
.el-textarea__inner::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #a6a8bf;
}

.el-textarea__inner::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #ededed;
}

.el-textarea__inner::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.el-textarea__inner {
  resize: none;
}
</style>